<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Base64 } from "js-base64";
export default {
  name: "app",
  mounted () {
    window.onresize = () => {
      this.$store.commit("changeWidth", document.body.clientWidth);
      this.$store.commit("changeHeight", document.body.clientHeight);
    };
  },
  watch: {
    $route (to) {
      /* 路由发生变化修改页面title */
      if (
        to.path == "/success" ||
        (this.myQuery &&
          this.myQuery.type == "public" &&
          to.path == "/question")
      ) {
        document.title = this.$t("message.question_public_title");
      } else {
        document.title = this.$t("message.web_title");
      }
    }
  },
  computed: {
    myQuery () {
      let url = this.$route.query.code
        ? Base64.decode(this.$route.query.code)
        : null;
      if (url) {
        let hash;
        var myJson = {};
        var hashes = url.split("&");
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split("=");
          myJson[hash[0]] = hash[1];
        }
        return myJson;
      } else {
        return null;
      }
    }
  },
  methods: {},
  created () {
    // 打印版本信息
    console.log(`Version: ${process.env.VUE_APP_VERSION}, ENV: ${process.env.NODE_ENV}`);
    // 根據url參數設定語言
    if (this.$route.query.lang) {
      localStorage.setItem("lan", this.$route.query.lang.toUpperCase());
      this.$i18n.locale = this.$route.query.lang.toUpperCase();
      if (this.$route.query.lang.toUpperCase() == "EN") {
        localStorage.setItem("sound", "E");
      } else if (this.$route.query.lang.toUpperCase() == "PT") {
        localStorage.setItem("sound", "P");
      } else if (this.$route.query.lang.toUpperCase() == "ZH_CN") {
        localStorage.setItem("sound", "CN");
      } else {
        localStorage.setItem("sound", "TW");
      }
    }

    /* 路由发生变化修改页面title */
    const to = this.$route.query;
    // console.log("to:", to);
    // console.log(
    //   this.myQuery && this.myQuery.type == "public" && to.path == "/question"
    // );
    if (this.myQuery && this.myQuery.type == "public") {
      document.title = this.$t("message.question_public_title");
    } else {
      document.title = this.$t("message.web_title");
    }

    // 判断是否為蘋果系統（iOS、Mac OS X）
    this.$store.commit(
      "changeIsApple",
      /(iPhone|iPad|iPod|iOS|Mac OS X)/i.test(navigator.userAgent)
    );

    this.$store.commit("changeLan", this.$i18n.locale);
    this.$store.commit("changeWidth", document.body.clientWidth);
    this.$store.commit("changeHeight", document.body.clientHeight);
    if (localStorage.getItem("sound")) {
      return;
    } else {
      localStorage.setItem("sound", "TW");
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-table th > .cell {
  word-break: break-word;
  padding-right: 0px;
}
/deep/.el-table .cell {
  word-break: break-word;
}
</style>
<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  background: #f2f2f6;
  /* overflow-x: hidden;
  min-width: 1200px; */
}
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
ul {
  margin: 0;
  padding: 0;
}
:focus {
  outline-color: transparent;
}
img {
  height: auto;
}
.container {
  max-width: 1200px;
  padding-left: 14px;
  padding-right: 14px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}
.container_nopadding {
  max-width: 1200px;
  padding: 0;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}
.container_padding {
  max-width: 1200px;
  padding: 14px 14px 0 14px;
  margin-left: auto;
  margin-right: auto;
  /* height: calc(100% - 44px); */
}
.row {
  display: flex;
  flex-direction: row;
}
.column {
  display: flex;
  flex-direction: column;
}
.row-align-center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.justify-align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.row-align-center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.justify-space-between {
  display: flex;
  justify-content: space-between;
}
.justify-space-around {
  display: flex;
  justify-content: space-around;
}

.pointer {
  cursor: pointer;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f0f3f5 !important;
}

.el-table .cell,
.el-table th div,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 3% !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td:first-child {
  /* border-left: 1px solid red; */
}
.el-table--enable-row-hover .el-table__body tr:hover > td div {
  color: #35b08e !important;
}
.el-table .cell {
  font-size: 16px;
  color: #4a4a4a;
}
.m-btn {
  padding: 8px 0;
  width: 100%;
  border-radius: 4px;
  border: 1px solid rgba(22, 182, 149, 1);
  color: #16b695;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc !important;
  background-color: #fff !important;
  border-color: #ebeef5 !important;
}
.el-radio,
.el-radio__input,
.el-checkbox__label {
  white-space: inherit !important;
}

/* 處理富文本 */
.html-box >>> img {
  display: block;
  margin: 0 auto;
  max-width: 100% !important;
  height: auto !important;
}
.html-box >>> p {
  max-width: 100%;
  word-break: break-all;
}
.html-box >>> span {
  max-width: 100%;
  word-break: break-all;
  font-size: 18pt;
  line-height: 200%;
  font-weight: normal;
  font-style: normal;
}
.html-box >>> table {
  width: 100%;
  background: #fff;
}
.html-box img {
  display: block;
  margin: 0 auto;
  max-width: 100% !important;
  height: auto !important;
}
.html-box p {
  max-width: 100%;
  word-break: break-all;
}
.html-box {
  max-width: 100%;
  /* word-break: break-all; */
  font-size: 18pt;
  line-height: 200%;
  font-weight: normal;
  font-style: normal;
}
.html-box table {
  width: 100% !important;
  background: #fff;
}
.html-box ul {
  padding-left: 40px;
}

/* 文本行数控制 */

.max-line-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.max-line-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.max-line-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.max-line-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.el-message {
  max-width: 500px;
  width: 90%;
  min-width: 300px !important;
}
.el-checkbox__label {
  white-space: normal !important;
}
.el-message-box {
  max-width: 420px !important;
  width: 90% !important;
}
.el-menu-item,
.el-submenu__title {
  white-space: normal !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 25px !important;
  min-height: 56px !important;
  height: auto !important;
}
.el-submenu__title > div {
  flex: 1;
  padding: 10px 0;
}
</style>
